import React from "react";
import GenericFallBackUI from "./generic_fallback";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    //TODO add sentry or other error reporting service
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }

      return (
        <GenericFallBackUI
          containerClass={this.props.containerClass}
          fullPage={this.props.fullPage}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
